export const name = 'carelinelive';

export const base = 'teal';

export const map = {
    '50': 'E3F5F3',
    '100': 'BBE6E3',
    '200': '91D7D2',
    '300': '62C7BF',
    '400': '3CBBB1',
    '500': '01AFA4',
    '600': '019F95',
    '700': '058E85',
    '800': '067C74',
    '900': '095B55',
};

export function apply($mdThemingProvider) {
    $mdThemingProvider.definePalette(name, $mdThemingProvider.extendPalette(base, map));

    $mdThemingProvider
        .theme('default')
        .primaryPalette(name)
        .accentPalette('blue-grey');
}
